

























































































// @ is an alias to /src
import apiFlux from '@/api/flux'
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux';
import { toSubArray, toNumberDictionary, toNumberLookup } from '@/utils/groupBy';
import { AloItemflux, getDefaultAloItemflux } from '@/models/alo/AloItemflux';
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType';
import { directPayloadQuery } from '@/utils/api';

@Component({
  name: 'EditItemFlux',    
  components:{EditDrawer},   
})
export default class EditItemFlux extends Vue {
  
  private headersUni = [
    { text: '', value: 'id',width:30 },
    { text: 'Univers', value: 'libelle' },
    { text: '', value: 'selected',width:30 }
  ]

  private headersRub = [
    { text: '', value: 'id',width:10 },
    { text: 'Rubrique', value: 'libelle' },    
    { text: '', value: 'selected',width:30 }
  ]

  private headersFam = [
    { text: '', value: 'id',width:10 },
    { text: 'Famille', value: 'libelle' }    
  ]

  private original:Array<AloItemflux> = []
  private modified:Array<AloItemflux> = []
  private showDrawer = false
  private saving = false 
  private direction = 0
  private fluxId = -1
  //les id des items selectionnées
  private selectedUnivers = {id:-1}
  private selectedRubrique = {id:-1}
  
  
  edit(items:Array<AloItemflux>,fluxId:number,direction:number) {    
    this.selectedUnivers = {id:-1}
    this.selectedRubrique = {id:-1}
    this.direction = direction
    this.fluxId = fluxId
    this.$store.myActions.ADM_FLUX_RESET_STATUS()
    this.showDrawer = true
    this.original = items
    this.modified = cloneDeep(items)    
  }  

  get isCatalogue() {
    return this.modified.some(it => it.itfFid == 0 && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Catalogue)
  }

  set isCatalogue(selected) {
    if(selected) {
      this.modified.push({
        ...getDefaultAloItemflux(),
        flxId:this.fluxId,
        itfDirection:this.direction,
        itfTypObj:ItemfluxObjectType.Catalogue,
        itfFid:0
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.itfFid == 0 && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Catalogue),1)
    }
  }

  get dicUniItemFlux() {
    return toNumberDictionary(this.modified.filter(it => it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Univers),it => it.itfFid)
  }

  get dicRubItemFlux() {
    return toNumberDictionary(this.modified.filter(it => it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Rubrique),it => it.itfFid)
  }

  get dicFamItemFlux() {
    return toNumberDictionary(this.modified.filter(it => it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Famille),it => it.itfFid)
  }  

  get dicUniChildSelected() {
    return this.modified.filter(it => it.itfDirection == this.direction).reduce((acc,it) => {
      if(it.itfTypObj == ItemfluxObjectType.Rubrique) acc[this.rubriques[it.itfFid].uniId] = true
      else if(it.itfTypObj == ItemfluxObjectType.Famille) acc[this.familles[it.itfFid].uniId] = true
      return acc
    },{} as {[index:number]:boolean}) 
  }

  get dicRubChildSelected() {
    return this.modified.filter(it => it.itfDirection == this.direction).reduce((acc,it) => {      
      if (it.itfTypObj == ItemfluxObjectType.Famille) acc[this.familles[it.itfFid].rubId] = true
      return acc
    },{} as {[index:number]:boolean})
  }


  get title() {
    return this.direction?"Sélection des catégories à exporter :":"Sélection des catégories à exclure du flux :"
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get fluxStatus() {
    return this.$store.myGetters.fluxStatus
  }

  get universList(){
    return this.$store.myGetters.universList
  }

  get rubriques(){
    return this.$store.myGetters.rubriques
  }

  get rubriquesList(){
    return this.$store.myGetters.rubriquesList
  }

  get familles(){
    return this.$store.myGetters.familles
  }

  get famillesList(){
    return this.$store.myGetters.famillesList
  }

  get displayUnivers() {
    return this.universList.map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicUniItemFlux[it.id],
        childSelected:!!this.dicUniChildSelected[it.id],
        parentSelected:this.isCatalogue
      }
    })
  }

  get displayRubrique() {
    return this.rubriquesList.filter(r => r.uniId == this.selectedUnivers.id).map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicRubItemFlux[it.id],
        childSelected:!!this.dicRubChildSelected[it.id],
        parentSelected:!!this.dicUniItemFlux[it.uniId] || this.isCatalogue
      }
    })
  }

  get displayFamille() {
    return this.famillesList.filter(f => f.rubId == this.selectedRubrique.id).map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicFamItemFlux[it.id],
        childSelected:false,
        parentSelected:!!this.dicUniItemFlux[it.uniId] || !!this.dicRubItemFlux[it.rubId] || this.isCatalogue
      }
    })
  }

  created(){
    this.$store.myActions.CATALOGUE_TREE_ENSURE()
  }

  selectUnivers(item: any) {
    if(item.id != this.selectedUnivers.id) this.selectedRubrique = {id:-1}
    this.selectedUnivers = item    
  }

  selectRubrique(item: any) {
    this.selectedRubrique = item
  }


  updateUnivers(id:number,selected:boolean) {
    if(selected) {
      this.modified.push({
        ...getDefaultAloItemflux(),
        flxId:this.fluxId,
        itfDirection:this.direction,
        itfTypObj:ItemfluxObjectType.Univers,
        itfFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.itfFid == id && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Univers),1)
    }
  }

  updateRubrique(id:number,selected:boolean){    
    if(selected) {
      this.modified.push({
        ...getDefaultAloItemflux(),
        flxId:this.fluxId,
        itfDirection:this.direction,
        itfTypObj:ItemfluxObjectType.Rubrique,
        itfFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.itfFid == id && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Rubrique),1)
    }
  }

  updateFamille(id:number,selected:boolean){
    if(selected) {
      this.modified.push({
        ...getDefaultAloItemflux(),
        flxId:this.fluxId,
        itfDirection:this.direction,
        itfTypObj:ItemfluxObjectType.Famille,
        itfFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.itfFid == id && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Famille),1)
    }
  }

  deleteItemFlux(id:number){
    const idx = this.modified.findIndex(it => it.id == id)    
    if(idx > -1)  {
      this.modified.splice(idx,1)
      this.saveData()
    }
  }

  saveData() {        
    this.saving = true
    directPayloadQuery(apiFlux.saveItemFlux,{id:this.fluxId,fluxItems:this.modified},this.$store).then((items)=>{
      this.original.splice(0,this.original.length,...items)
      this.showDrawer = false
    }).finally(() => {
      this.saving = false
    })     
  }

  
}
